export const processItem = (sr, date, time, partyName, cid, formData) => {
  const { isCompleted, completionDate } = getTxStatus(formData);
  const dateTime = date + " " + time;
  const transactionDate = new Date(dateTime);

  return {
    description: formData?.description,
    sr,
    partyName,
    customerId: cid,
    weight: formData?.weight,
    amount: formData?.amount,
    rate: formData?.rate,
    diff: formData?.diff,
    rwType: formData?.rwType,
    postDate: completionDate,
    status: isCompleted ? "D&L" : "Pending",
    transactionDate,
    date,
    time,
  };
};

export const buySellTxResponseTransform = (data, type) => {
  const transform = (apiItem) => ({
    transactionId: apiItem?.transactionId,
    description: apiItem?.description,
    sr: apiItem?.serialNo,
    partyName: apiItem?.customer,
    weight: apiItem?.weight,
    amount: apiItem?.amount,
    rate: apiItem?.rate,
    diff: apiItem?.diff,
    rwType: apiItem?.rwType,
    postDate: apiItem?.postDate,
    status: apiItem?.status,
    date: apiItem?.createdAt || apiItem?.postData,
    time: new Date(apiItem.createdAt).toLocaleTimeString(),
    isCompleted: apiItem.isCompleted,
  });

  return data.reduce(
    (acc, item) => {
      if (item.section === "receive") {
        acc.receive.push({ ...transform(item), section: "receive", type });
      } else if (item.section === "given") {
        acc.given.push({ ...transform(item), section: "given", type });
      }
      return acc;
    },
    { receive: [], given: [] },
  );
};

function getTxStatus(data) {
  let completionDate = null;

  let isCompleted = data?.status === "D&L";

  completionDate = new Date(data.postDate);

  return { completionDate, isCompleted };
}

export const transformPayload = (data) => {
  const amount = num(data.amount);
  const weight = num(data.weight);
  const rate = num(data.rate);
  const diff = num(data.diff);

  return {
    description: data?.description,
    weight,
    rate: num(rate),
    amount: num(amount),
    diff: num(diff),
    totalAmount: num(amount),
    netAmount: amount,
    netWeight: weight,
    postDate: data?.postDate,
    status: data?.status,
    isRateApplied: true,
  };
};

export const proccessedPayload = (
  newDataObject,
  component = "goldRateWork",
) => {
  const buyTx = newDataObject?.buy;
  const sellTx = newDataObject?.sell;

  console.log({ buyTx, sellTx });

  if (!buyTx && !sellTx) {
    alert("No transaction found!");
    return;
  }

  const data = {};

  // Case 1: Both exist and same sr
  if (buyTx && sellTx && buyTx.sr === sellTx.sr) {
    data.serialNumber = buyTx.sr;
    data.customerId = buyTx.customerId;
    data.receive = { [component]: transformPayload(buyTx) };
    data.given = { [component]: transformPayload(sellTx) };
    data.note = `Given ${component === "goldRateWork" ? "Gold" : "Silver"} Rate Work | Receive ${component === "goldRateWork" ? "Gold" : "Silver"} Rate Work`;
    data.transactionDate = buyTx.transactionDate;
  }

  // Case 2: Only buy exists
  else if (buyTx) {
    data.serialNumber = buyTx.sr;
    data.customerId = buyTx.customerId;
    data.receive = { [component]: transformPayload(buyTx) };
    data.note = `Received ${component === "goldRateWork" ? "Gold" : "Silver"} Rate Work`;
    data.transactionDate = buyTx.transactionDate;
  }

  // Case 3: Only sell exists
  else if (sellTx) {
    data.serialNumber = sellTx.sr;
    data.customerId = sellTx.customerId;
    data.given = { [component]: transformPayload(sellTx) };
    data.note = `Given ${component === "goldRateWork" ? "Gold" : "Silver"} Rate Work`;
    data.transactionDate = sellTx.transactionDate;
  }

  return data;
};

const num = (val) => Number(val || 0);

export const transactionValidation = (buyTx, sellTx) => {
  let errors = [];

  const isBuyTx = isTransactionEntered(buyTx);
  const isSellTx = isTransactionEntered(sellTx);
  if (isBuyTx) {
    errors = [...errors, ...validateSingleTx(buyTx, "Buy")];
  }

  if (isSellTx) {
    errors = [...errors, ...validateSingleTx(sellTx, "Sell")];
  }

  return { errors, isBuyTx, isSellTx };
};

const validateSingleTx = (tx, label) => {
  const errors = [];

  if (!tx.weight) {
    errors.push(`${label}: Weight is required`);
  }

  if (!tx.rate) {
    errors.push(`${label}: Rate is required`);
  }

  if (!tx.amount) {
    errors.push(`${label}: Amount is required`);
  }

  if (!tx.postDate) {
    errors.push(`${label}: Post Date is required`);
  }

  return errors;
};

const isTransactionEntered = (tx) => {
  return Number(tx.weight) > 0 || Number(tx.rate) > 0 || Number(tx.amount) > 0;
};
